import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RequestOptions, Headers } from '@angular/http';
import { baseAPI, baseUrl, gatewayFile } from './endpoint';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalEventsManager } from './global-events-manager';
import AppLink from 'src/AppLink';
import { AgencyEmailData } from './nav/agency-email-dialog/agency-email-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class NavService {

  private url = baseUrl + gatewayFile;
  private baseAPI = baseAPI;

  constructor(
    private http: HttpClient,
    private router: Router,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getAppLinks(): Observable<AppLink[]> {
    const bodyRequest = {
      token: localStorage.getItem('token'),
      internalOrExternal: 'internal'
    };

    return this.http.post<AppLink[]>(`${baseAPI}/insync/getApps`, bodyRequest)
    .pipe(
      catchError(this.handleError('getAppLinks', []))
    );
  }

  getActiveBranches( ): Observable<string[]> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getAllActiveBranches' })
    .pipe(
      catchError(this.handleError('getAllActiveBranches', []))
    );
  }

  getAgencyScheduledForTodayAndTomorrow(dates: string[]): Observable<AgencyEmailData[]> {
    const url = `${this.baseAPI}/insync/getAgencyScheduledForTodayAndTomorrow`;
    return this.http.post<AgencyEmailData[]>(url, { token: localStorage.getItem('token'), internalOrExternal: 'internal', dates })
    .pipe(
      catchError(this.handleError('getAgencyScheduledForTodayAndTomorrow', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
